const Body = ({ children }) => (
    <div className="m-3">
        {children}
    </div>
)

export default Body